import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M10.327 10.662a.751.751 0 0 1-.531-.219 2.412 2.412 0 0 0-3.336 0A.751.751 0 1 1 5.4 9.382a3.953 3.953 0 0 1 5.46 0 .749.749 0 0 1-.531 1.28Zm2.33-2.228a.75.75 0 0 0 0-1.061 6.4 6.4 0 0 0-9.057 0 .75.75 0 0 0 1.06 1.061 4.9 4.9 0 0 1 6.937 0 .748.748 0 0 0 1.06 0Zm2-1.924a.749.749 0 0 0 0-1.06 9.243 9.243 0 0 0-13.057 0 .75.75 0 1 0 1.06 1.06 7.745 7.745 0 0 1 10.937 0 .748.748 0 0 0 1.06 0ZM8.139 11a1.205 1.205 0 1 0 1.2 1.21 1.208 1.208 0 0 0-1.2-1.21Z';
const draw24px =
  'M15.63,16.893a.749.749,0,0,1-.53-.219,4.387,4.387,0,0,0-6.2,0,.75.75,0,0,1-1.06-1.061,5.886,5.886,0,0,1,8.32,0,.75.75,0,0,1-.53,1.28Zm3.5-3.462a.75.75,0,0,0,0-1.061,10.083,10.083,0,0,0-14.259,0,.75.75,0,0,0,1.061,1.061,8.581,8.581,0,0,1,12.137,0,.752.752,0,0,0,1.061,0Zm3.3-3.3a.75.75,0,0,0,0-1.061,14.77,14.77,0,0,0-20.861,0,.75.75,0,0,0,1.061,1.061,13.266,13.266,0,0,1,18.739,0,.752.752,0,0,0,1.061,0ZM12.009,17.406a1.5,1.5,0,1,0,1.5,1.5A1.511,1.511,0,0,0,12.009,17.406Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const SignalIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'signal'),
) as IconWithRender;

SignalIcon.displayName = 'SignalIcon';
SignalIcon.propTypes = Icon.propTypes;
SignalIcon.renderIcon = (props) => <SignalIcon {...props} />;
export default SignalIcon;
